// extracted by mini-css-extract-plugin
export var container = "_4v-0";
export var disabled = "_4v-4";
export var fullWidth = "_4v-3";
export var lined = "_4v-1";
export var selected = "_4v-5";
export var tab = "_4v-2";